import { bindable, bindingMode, computedFrom } from 'aurelia-framework';
import { PaymentLimitSettings } from '../../models/payment-limit-settings';
import { Uuid } from '../../../helpers/uuid';

export class ShortPayReason {
	@bindable({ defaultBindingMode: bindingMode.twoWay }) paymentLimitSettings: PaymentLimitSettings = new PaymentLimitSettings();

	shortPayReasonOptions: IShortPayReasonOption[] = [];
	readonly uuid: string;

	constructor() {
		this.uuid = Uuid.next();

	}

	paymentLimitSettingsChanged(newValue: PaymentLimitSettings, oldValue: PaymentLimitSettings) {
		if (newValue && newValue.shortPayReasons) {
			for (let i = 0; i < newValue.shortPayReasons.length; i++) {
				this.shortPayReasonOptions.push( { id: i, value: newValue.shortPayReasons[i] } as IShortPayReasonOption);
			}
		}
	}

	@computedFrom('paymentLimitSettings.selectedShortPayReason')
	get showCommentBox(): boolean {
		if (this.paymentLimitSettings && this.paymentLimitSettings.selectedShortPayReason === -1) {
			return true;
		}

		if (this.paymentLimitSettings) {
			this.paymentLimitSettings.shortPayComment = '';
		}

		return false;
	}

	@computedFrom('shortPayReasonOptions')
	get shortPayListboxOptions() {
		if (this.paymentLimitSettings.enableShortPayUserComment) {
			return [...this.shortPayReasonOptions.map(opt => opt.id), -1];
		} else {
			return this.shortPayReasonOptions.map(opt => opt.id);
		}
	}

	@computedFrom('shortPayReasonOptions')
	get shortPayListboxDescriptions() {
		if (this.paymentLimitSettings.enableShortPayUserComment) {
			return [...this.shortPayReasonOptions.map(opt => opt.value), 'Other'];
		} else {
			return this.shortPayReasonOptions.map(opt => opt.value);
		}
	}
}

export interface IShortPayReasonOption {
	id: number;
	value: string;
}
